import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const useStore = create()(
  persist(
    (set) => ({
      questionnaireTimerVisible: false,
      timerVisible: false,
      applicationStartTime: null,
      isModalInstructionsOpen: false,
      questionnaires: { finished: 0, started: 0, total: 0 },
      assignappId: undefined,
      showCloseApplicationModal: false,
      closeApplication: false,
      userHasClosedApplicationModal: false,
      showUserCreatedInfoModal: false,

      surveyId: undefined,

      applicacionData: {
        name: "",
        instructions: "",
        time_warning_minutes: 0,
        time_close_warning_minutes: 0,
        time_auto_close_minutes: 0,
        timed: true,
      },

      setTimerVisible: (timerVisible) => set({ timerVisible }),
      resetStopwatchValue: () => set({ applicationStartTime: null }),
      setIsModalInstructionsOpen: (isModalInstructionsOpen) => set({ isModalInstructionsOpen }),
      setQuestionnaires: ({ finished, pending, total }) => set(() => ({ questionnaires: { finished, pending, total } })),
      setApplicationStartTime: (applicationStartTime) => set({ applicationStartTime }),
      setAssignappId: (assignappId) => set({ assignappId }),
      setShowCloseApplicationModal: (showCloseApplicationModal) => set({ showCloseApplicationModal }),
      setCloseApplication: (closeApplication) => set({ closeApplication }),
      setUserHasClosedApplicationModal: (userHasClosedApplicationModal) => set({ userHasClosedApplicationModal }),

      setSurveyId: (surveyId) => set({ surveyId }),

      setApplicacionData: (applicacionData) => set({ applicacionData }),
      setShowUserCreatedInfoModal: (value) => set({ showUserCreatedInfoModal: value }),
    }),
    {
      name: "superfinanciera-settings",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
